export const APPSTORE_URL =
  "https://apps.apple.com/se/app/finanslicenser/id6476060612";

export type OpenAIModel = {
  id: string;
  name: string;
};

/**
 * List of available OpenAI models.
 */
export const availableModels: Array<OpenAIModel> = [
  { id: "gpt-4.1-2025-04-14", name: "GPT-4,1" },
  { id: "gpt-4.1-mini-2025-04-14", name: "gpt-4.1-mini" },
  { id: "gpt-4.1-nano-2025-04-14", name: "gpt-4.1-nano" },
  { id: "gpt-4o-mini-2024-07-18", name: "GPT-4o Mini" },
  { id: "gpt-4o-2024-08-06", name: "GPT-4o" },
];

export const keyboardKeys = {
  ENTER: "Enter",
  ESCAPE: "Escape",
};

export const MIXPANEL_TOKEN_VERSION =
  process.env.REACT_APP_MIXPANEL_TOKEN_VERSION || "dev";
export const SHOW_CONTINUE_BUTTON_IN_SMART_CHAT =
  process.env.REACT_APP_SHOW_CONTINUE_BUTTON_IN_SMART_CHAT === "true";
export const ALLOW_COPY_PASTE =
  process.env.REACT_APP_ALLOW_COPY_PASTE === "true";
export const SHOW_CORRECT_ANSWERS =
  process.env.REACT_APP_SHOW_CORRECT_ANSWERS === "true";
export const ALWAYS_SHOW_REVIEW_POPUP =
  process.env.REACT_APP_ALWAYS_SHOW_REVIEW_POPUP === "true" || false;
export const USE_CACHE = process.env.REACT_APP_USE_CACHE === "true";
export const SHOW_DEBUG_CHAT_BUTTON =
  process.env.REACT_APP_SHOW_DEBUG_CHAT_BUTTON === "true";
/** AI chat (theory lessons + learning format choice) — off by default; see util/aiChatDebugFlag.ts */
export const ENABLE_AI_CHAT =
  process.env.REACT_APP_ENABLE_AI_CHAT === "true";
export const DISABLE_LEAVE_STEP_CONFIRMATION =
  process.env.REACT_APP_DISABLE_LEAVE_STEP_CONFIRMATION === "true";
export const DISABLE_PRELOAD_NEXT_LEVEL =
  process.env.REACT_APP_DISABLE_PRELOAD_NEXT_LEVEL === "true";
export const USE_EMAIL_TEMPLATE_FOR_ADD_EMPLOYEES =
  process.env.REACT_APP_USE_EMAIL_TEMPLATE_FOR_ADD_EMPLOYEES !== "false";

/** UI showroom at /ui-elements — dev and staging only (tree-shaken from prod builds). */
export const IS_UI_ELEMENTS_ENABLED =
  process.env.NODE_ENV === "development" ||
  process.env.REACT_APP_ENABLE_UI_ELEMENTS === "true";

// Questions per subtest override from environment
// Only applies in development mode, production always uses default (10)
const parsedQuestionsPerSubtest = (() => {
  if (process.env.NODE_ENV === "production") {
    return NaN;
  }
  const raw = process.env.REACT_APP_QUESTIONS_PER_SUBTEST;

  // If raw is null, undefined, empty string, or only whitespace, return NaN
  if (raw == null || String(raw).trim() === "") {
    return NaN;
  }
  const trimmed = String(raw).trim();
  const n = parseInt(trimmed, 10);
  // If parsing resulted in NaN or the trimmed value doesn't match the parsed number, return NaN
  // This handles cases where the value is not a valid number
  if (Number.isNaN(n) || String(n) !== trimmed) {
    return NaN;
  }
  return n;
})();

export const QUESTIONS_PER_SUBTEST_OVERRIDE: number | undefined =
  Number.isFinite(parsedQuestionsPerSubtest)
    ? Math.min(100, Math.max(1, parsedQuestionsPerSubtest))
    : undefined;

